<template>
  <Modal title="调课件" v-model="visible">
    <Form ref="lessonForm" class="form" 
      :model="lessonParam"
      :label-width="80">
      <Row>
        <Col :span="22">
          <Form-item label="开始Level" prop="classType">
            <Select v-model.number="lessonParam.classType">
              <Option v-for="item in $constant.classType"
                :value="item.code" :key="item.code">{{ item.text }}</Option>
            </Select>
          </Form-item>
        </Col>
        </Col>
      </Row>
    </Form>
    <div slot="footer">
      <Button type="text" size="large" @click="visible=false">取消</Button>
      <Button type="primary" size="large" :loading="loadingChange" @click="change">确定</Button>
    </div>
  </Modal>
</template>
<script>
  export default {
    name: 'ChangeLessonModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      classType: {
        type: Number
      },
      successCallback: {
        type: Function
      }
    },
    data () {
      return {
        visible: this.value,
        lessonParam: {
          classType: null
        },
        loadingChange: false,
      }
    },
    methods: {
      change () {
        let self = this
        self.loadingChange = true
        self.$refs.lessonForm.validate((valid) => {
          if (!valid) {
            self.$Message.warning('信息输入错误!')
            self.loadingChange = false
            return
          }
          self.loadingChange = false
          // self.$http.post('/user/lesson/addCourse', self.testNetworkParam).then(function (res) {
          //   self.loadingTestNetwork = false
          //   if (res) {
          //     self.$Message.success('约课成功!')
          //     self.visible = false
          //     return
          //   }
          // })
        })
      }
    },
    watch: {
      value (val) {
        this.visible = val
      },
      visible (val) {
        if (val === true) {
          this.lessonParam.classType = this.classType
        }
        this.$emit('input', val)
      }
    }
  }  
</script>



// WEBPACK FOOTER //
// ChangeClassTypeModal.vue?0beb3230